
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...ccDetailsSlugFR]",
      function () {
        return require("private-next-pages/[...ccDetailsSlugFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...ccDetailsSlugFR]"])
      });
    }
  